module.exports = __webpack_public_path__ + "img/SjlModel.e6f08f59.jpg";